var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32730)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01887 3.61969V14.5761H5.0625V3.375H7.01887V3.61969ZM8.41331 3.375H9.51356C11.7883 3.375 13.3048 4.81781 13.3048 6.87206C13.3048 8.53538 12.3992 9.80719 10.7606 10.2229L13.6221 14.5761H11.3231L7.41037 8.51062H9.29362C10.5407 8.51062 11.3231 7.94812 11.3231 6.84787C11.3231 5.74706 10.5412 5.18456 9.29362 5.18456H8.4375V3.375H8.41331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRap);
export default __webpack_public_path__ + "static/media/rap.be236e815da9fc52de6763e176c4642a.svg";
export { ForwardRef as ReactComponent };